import { z } from 'zod'

export const projectApiKeySchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  key_prefix: z.string(),
  description: z.string().nullable(),
  is_active: z.boolean(),
  last_used_at: z.string().nullable(),
  created_at: z.string(),
  revoked_at: z.string().nullable(),
})

export type ProjectApiKey = z.infer<typeof projectApiKeySchema>

export const projectApiKeyListResponseSchema = z.object({
  api_keys: z.array(projectApiKeySchema),
  total: z.number(),
})

export type ProjectApiKeyListResponse = z.infer<typeof projectApiKeyListResponseSchema>

export const projectApiKeyCreateRequestSchema = z.object({
  name: z.string().min(1, 'Nome obrigatório').max(255, 'Máximo 255 caracteres'),
  description: z.string().max(500, 'Máximo 500 caracteres').optional(),
})

export type ProjectApiKeyCreateRequest = z.infer<typeof projectApiKeyCreateRequestSchema>

export const projectApiKeyCreateResponseSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  key: z.string(),
  key_prefix: z.string(),
  description: z.string().nullable(),
  created_at: z.string(),
  message: z.string(),
})

export type ProjectApiKeyCreateResponse = z.infer<typeof projectApiKeyCreateResponseSchema>

export const projectApiKeyRevokeResponseSchema = z.object({
  message: z.string(),
})

export type ProjectApiKeyRevokeResponse = z.infer<typeof projectApiKeyRevokeResponseSchema>
